import { render, staticRenderFns } from "./NavPageView.vue?vue&type=template&id=6fd52d1a&scoped=true"
import script from "./NavPageView.vue?vue&type=script&lang=js"
export * from "./NavPageView.vue?vue&type=script&lang=js"
import style0 from "./NavPageView.vue?vue&type=style&index=0&id=6fd52d1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd52d1a",
  null
  
)

export default component.exports